"use client";
import { createTheme } from "@mantine/core";
import colors from "../colors";

// input label theme obj;
const inputLabels = {
  fontWeight: 500,
  fontSize: "12px",
  color: `${colors.gray["700"]}`,
};

// input input theme obj;
const inputInputs = {
  height: 36,
  borderRadius: 6,
  fontSize: "13px",
};

export const theme = createTheme({
  components: {
    // Add Mantine component overrides here
    ColorInput: {
      styles: () => ({
        label: inputLabels,
      }),
    },
    DatePickerInput: {
      styles: () => ({
        label: inputLabels,
      }),
    },
    Button: {
      styles: () => ({
        root: {
          borderRadius: 0,
          height: 36,
        },
        label: {
          fontWeight: 500,
          fontWeight: "normal",
          fontSize: "14px",
        },
      }),
    },
    PasswordInput: {
      styles: () => ({
        input: inputInputs,
        label: inputLabels,
      }),
    },
    Stepper: {
      styles: () => ({}),
    },
    Input: {
      styles: {
        input: inputInputs,
        label: inputLabels,
      },
    },
    TextInput: {
      styles: {
        input: inputInputs,
        label: inputLabels,
      },
    },
    FileInput: {
      styles: {
        input: inputInputs,
        label: inputLabels,
      },
    },
    LoadingOverlay: {
      styles: () => ({
        root: {
          "& svg": {
            fill: "#FF9283",
          },
        },
      }),
    },
    Autocomplete: {
      styles: () => ({
        input: {
          height: 54,
          borderRadius: 0,
          border: "1px solid #e6e6e6",
          "&:focus": {
            border: "1px solid #003893",
          },
        },
        label: {
          marginBottom: 8,
        },
      }),
    },
    Switch: {
      styles: () => ({
        label: {
          fontWeight: 500,
          fontSize: "12px",
          color: `${colors.gray["700"]}`,
        },
      }),
    },
    Tabs: {
      styles: () => ({
        tab: {
          paddingTop: 16,
          paddingBottom: 16,
          borderBottomWidth: 3,
        },
      }),
    },
    // Indicator: {
    //   styles: () => ({
    //     indicator: {
    //       backgroundColor: "#00000",
    //     },
    //   }),
    // },
    Textarea: {
      styles: () => ({
        input: {
          borderRadius: 6,
          border: `1px solid ${colors.gray[300]}`,
          height: 100,
        },
        label: inputLabels,
      }),
    },
    Checkbox: {
      styles: () => ({
        input: {
          cursor: "pointer",
        },
      }),
    },
    Divider: {
      styles: () => ({
        root: {
          borderColor: "#DBDCDC",
        },
      }),
    },
    Image: {
      styles: () => ({
        imageWrapper: {
          overflow: "hidden",
          "& img": {
            transition: "transform .5s ease;",
            "&:hover": {
              transform: "scale(1.1)",
            },
          },
        },
      }),
    },
    // RangeCalendar: {
    //   styles: () => ({
    //     weekday: {
    //       fontSize: "13px",
    //       lineHeight: "24px",
    //       fontWeight: 600,
    //       color: "#2B2929",
    //     },
    //     day: {
    //       "&[data-selected]": {
    //         backgroundColor: "#E6C6D1",
    //         color: "#2B2929",
    //       },
    //       "&[data-first-in-range]": {
    //         fontWeight: 600,
    //       },
    //       "&[data-last-in-range]": {
    //         fontWeight: 600,
    //       },
    //       "&[data-in-range]": {
    //         backgroundColor: "#E6C6D1",
    //         color: "#2B2929",
    //       },
    //     },
    //   }),
    // },
    // DateRangePicker: {
    //   styles: () => ({
    //     weekday: {
    //       fontSize: "13px",
    //       lineHeight: "24px",
    //       fontWeight: 600,
    //       color: "#2B2929",
    //     },
    //     description: {
    //       fontSize: "13px",
    //       lineHeight: "24px",
    //       backgroundColor: "#E6C6D1",
    //       color: "#2B2929",
    //       width: "max-content",
    //       padding: "4px 8px",
    //     },
    //     day: {
    //       "&[data-selected]": {
    //         backgroundColor: "#E6C6D1",
    //         color: "#2B2929",
    //       },
    //       "&[data-first-in-range]": {
    //         fontWeight: 600,
    //         backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.217391' y='0.217391' width='9.56522' height='9.56522' fill='white' stroke='%23E6C6D1' stroke-width='0.434783'/%3E%3C/svg%3E%0A")`,
    //         backgroundRepeat: "no-repeat no-repeat",
    //         backgroundPosition: "left top",
    //         backgroundSize: "10px 10px",
    //       },
    //       "&[data-last-in-range]": {
    //         fontWeight: 600,
    //         backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.217391' y='0.217391' width='9.56522' height='9.56522' fill='white' stroke='%23E6C6D1' stroke-width='0.434783'/%3E%3C/svg%3E%0A")`,
    //         backgroundRepeat: "no-repeat no-repeat",
    //         backgroundPosition: "right bottom",
    //         backgroundSize: "10px 10px",
    //       },
    //       "&[data-in-range]": {
    //         backgroundColor: "#E6C6D1",
    //         color: "#2B2929",
    //       },
    //     },
    //   }),
    // },
    Select: {
      styles: () => ({
        input: {
          height: 40,
          borderRadius: 0,
          fontSize: "14px",
          border: `1px solid ${colors.gray[300]}`,
        },
        label: inputLabels,
        item: {
          fontSize: "12px !important",
        },
        dropdown: {
          boxShadow:
            "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
          borderRadius: 0,
        },
      }),
    },
    MultiSelect: {
      styles: () => ({
        input: {
          height: 40,
          borderRadius: 0,
          border: "1px solid #828282",
          "&:focus-within": {
            border: "1px solid #E6C6D1",
          },
        },
        label: inputLabels,
        values: {
          height: 56,
        },
        searchInput: {
          height: 56,
          "&:focus-visible": {
            outline: "none",
          },
        },
      }),
    },
    Modal: {
      styles: () => ({
        root: {
          zIndex: 1005,
        },
        title: {
          color: colors.primary,
        },
      }),
    },
    Radio: {
      styles: () => ({}),
    },
    Container: {
      defaultProps: {
        sizes: {
          xs: 540,
          sm: 640,
          md: 768,
          lg: 1024,
          xl: 1200,
        },
      },
    },
  },
  primaryColor: "primary-orange",
  colors: {
    "primary-orange": [
      `${colors.primary}`,
      `${colors.primary}`,
      `${colors.primary}`,
      `${colors.primary}`,
      `${colors.primary}`,
      `${colors.primary}`,
      `${colors.primary}`,
      `${colors.primary}`,
      `${colors.primary}`,
      `${colors.primary}`,
    ],
  },
});
